var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"outlined":"","hide-details":"","dense":"","disabled":_vm.disabled,"value":_vm.value,"type":"time"},on:{"input":(v) => _vm.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }